'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndMedicare } from '../../Entities/Ind/IndMedicare';
import { IndMedicareCollection } from '../../Collections/Ind/IndMedicareCollection';

export class IndMedicareRepository extends CoreRepository {
  /*public getIndPhone(individualId: number, options: object = {}) {
    if (!options) {
      options = {};
    }
 
    return this.webAPI.getInd(individualId, options)
      .then(response => {
        let user = new Ind();
        user.hydrate(response);
 
        return user;
      });
 
  }
*/

  public createIndMedicare(indId: number, payload: any[]) {
    return this.webAPI.createIndMedicare(indId, payload).then((response) => {
      const indMedicare = new IndMedicare();
      indMedicare.hydrate(response);

      return indMedicare;
    });
  }

  public updateIndMedicare(indId: number, indMedicareId: number, payload: any[]) {
    return this.webAPI.updateIndMedicare(indId, indMedicareId, payload).then((response) => {
      return response;
    });
  }

  public moveIndMedicare(individualId: number, individualMedicareId: number, payload: any[]) {
    return this.webAPI
      .moveIndMedicare(individualId, individualMedicareId, payload)
      .then((response) => {
        return response;
      });
  }
}
